module.exports = __webpack_public_path__ + "img/happy_oliver_cathedral_thumb.8bd0b522.jpg";